import { AxiosResponse } from "axios";

import { authorizedAxios } from "../../../Actions/AxiosActions";
import { IMyReportsReport } from "../../../Models/IMyReportsReport";
import { IGetJobsRequest } from "../Models/Requests/IGetJobsRequest";
import { IGetRecentJobsRequest } from "../Models/Requests/IGetRecentJobsRequest";

export async function getReports(request: IGetJobsRequest) {
    try {
        const response: IMyReportsReport[] = await authorizedAxios(
            "POST",
            "/services/gps/Job/myReports",
            null,
            request
        );
        return response.map(r => ({...r, startDate: new Date(r.startDate), endDate: new Date(r.endDate), createdDateTime: new Date(r.createdDateTime)}));
    } catch (error) {
        throw error;
    };
};

export async function getRecentReports(request: IGetRecentJobsRequest) {
    try {
        const response: AxiosResponse = await authorizedAxios(
            "POST",
            "/services/gps/Job/recent",
            null,
            request
        );
        return response;
    } catch (error) {
        throw error;
    };
};

export async function deleteReport(jobId: string) {
    try {
        await authorizedAxios(
            "POST",
            `/services/gps/Job/delete/${jobId}`,
        );
    } catch (error) {
        throw error;
    };
};
